import { render } from "./ProjectsListView.vue?vue&type=template&id=2320bc34"
import script from "./ProjectsListView.vue?vue&type=script&lang=js"
export * from "./ProjectsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__